export default "__VITE_ASSET__BaIc8cZj__"